module.exports = __webpack_public_path__ + "static/media/pages2_thumb.b6b4e1d5.jpg";